import React,{useEffect,useState} from 'react'

const SunMoonRise = () => {

    const colorSun = "#e1c900";
    const colorMoon = "#384E75";
    const colorCircle_1 = "#ADADAD";

    const [colorStroke ,setColorStroke] = useState(colorSun);
    const [svgRotation, setSvgRotation] = useState( -180) ;
    const [progressStroke, setProgressStroke] = useState( 314 );
    const [iconRotation, setIconRotation ]=  useState(0 );
    const [sunriseMove, setSunriseMove ]=  useState(1);
    const [moonrieMove, setMoonrieMove ]=  useState(0);
    const [seconds, setSeconds] = useState(0);
    const isActive = true;

    useEffect(() => {
      let interval = null;
      
      if (isActive) {
        interval = setInterval(() => {
          setSeconds(seconds => seconds + 1);
          if(svgRotation === -180 && iconRotation === 180){
            setSvgRotation(0);   
            setMoonrieMove(1);
            setSunriseMove(0);
            setColorStroke(colorMoon);
          }else{
            setSvgRotation(-180);   
            setMoonrieMove(0);
            setSunriseMove(1);
            setColorStroke(colorSun);
          }
          setProgressStroke(314);  
          setIconRotation(0);
         
        }, 5000);
        
        setInterval(() => {
          setProgressStroke(628);
          setIconRotation(180);
         
        }, 4000);

      } 
      return () => clearInterval(interval);
    }, [seconds,iconRotation,svgRotation]);

    return (
        <div>
            <svg 
            width="238" 
            height="238" 
            viewBox="0 0 238 238" 
            style={{transform: `rotate(${svgRotation}deg)`}}
            >
            <circle 
                cx="119" 
                cy="119" 
                r="100" 
                fill="none" 
                stroke={colorCircle_1} 
                strokeWidth="3" 
                strokeDasharray="628, 628" 
                strokeLinecap="round"                 
                style={{transition: "all 4s ease 1s"}}/>
                
                {sunriseMove &&
                    <>
                        <circle cx="119" 
                            cy="119" 
                            r="100" 
                            fill="none" 
                            stroke="#ffd900" 
                            strokeWidth="3" 
                            strokeDasharray={`${progressStroke}, 628`}
                            strokeDashoffset="314" 
                            strokeLinecap="round" 
                            className="RCP__progress" 
                            style={{transition: "all 4s ease 1s"}}
                        />
                        <circle 
                            cx="200" 
                            cy="50%" 
                            r="16" 
                            fill="white" 
                            stroke="#ffd900" 
                            strokeWidth="3" 
                                style={{transformOrigin: "50% 50%", transform: `rotate(${iconRotation}deg) translate(19px)`, transition: "all 4s ease 1s"}}
                        />
                        <g  stroke={colorStroke} fill={colorStroke} x="200" y="50%"
                            style={{transformOrigin: "50% 50%", transform: `rotate(${iconRotation}deg) translate(204px,105px)`, transition: "all 4s ease 1s"}}>

                            <path d="M4.37,14.62c0-0.24,0.08-0.45,0.25-0.62c0.17-0.16,0.38-0.24,0.6-0.24h2.04c0.23,0,0.42,0.08,0.58,0.25
                            c0.15,0.17,0.23,0.37,0.23,0.61S8,15.06,7.85,15.23c-0.15,0.17-0.35,0.25-0.58,0.25H5.23c-0.23,0-0.43-0.08-0.6-0.25
                            C4.46,15.06,4.37,14.86,4.37,14.62z M7.23,21.55c0-0.23,0.08-0.43,0.23-0.61l1.47-1.43c0.15-0.16,0.35-0.23,0.59-0.23
                            c0.24,0,0.44,0.08,0.6,0.23s0.24,0.34,0.24,0.57c0,0.24-0.08,0.46-0.24,0.64L8.7,22.14c-0.41,0.32-0.82,0.32-1.23,0
                            C7.31,21.98,7.23,21.78,7.23,21.55z M7.23,7.71c0-0.23,0.08-0.43,0.23-0.61C7.66,6.93,7.87,6.85,8.1,6.85
                            c0.22,0,0.42,0.08,0.59,0.24l1.43,1.47c0.16,0.15,0.24,0.35,0.24,0.59c0,0.24-0.08,0.44-0.24,0.6s-0.36,0.24-0.6,0.24
                            c-0.24,0-0.44-0.08-0.59-0.24L7.47,8.32C7.31,8.16,7.23,7.95,7.23,7.71z M9.78,14.62c0-0.93,0.23-1.8,0.7-2.6s1.1-1.44,1.91-1.91
                            s1.67-0.7,2.6-0.7c0.7,0,1.37,0.14,2.02,0.42c0.64,0.28,1.2,0.65,1.66,1.12c0.47,0.47,0.84,1.02,1.11,1.66
                            c0.27,0.64,0.41,1.32,0.41,2.02c0,0.94-0.23,1.81-0.7,2.61c-0.47,0.8-1.1,1.43-1.9,1.9c-0.8,0.47-1.67,0.7-2.61,0.7
                            s-1.81-0.23-2.61-0.7c-0.8-0.47-1.43-1.1-1.9-1.9C10.02,16.43,9.78,15.56,9.78,14.62z M11.48,14.62c0,0.98,0.34,1.81,1.03,2.5
                            c0.68,0.69,1.51,1.04,2.49,1.04s1.81-0.35,2.5-1.04s1.04-1.52,1.04-2.5c0-0.96-0.35-1.78-1.04-2.47c-0.69-0.68-1.52-1.02-2.5-1.02
                            c-0.97,0-1.8,0.34-2.48,1.02C11.82,12.84,11.48,13.66,11.48,14.62z M14.14,22.4c0-0.24,0.08-0.44,0.25-0.6s0.37-0.24,0.6-0.24
                            c0.24,0,0.45,0.08,0.61,0.24s0.24,0.36,0.24,0.6v1.99c0,0.24-0.08,0.45-0.25,0.62c-0.17,0.17-0.37,0.25-0.6,0.25
                            s-0.44-0.08-0.6-0.25c-0.17-0.17-0.25-0.38-0.25-0.62V22.4z M14.14,6.9V4.86c0-0.23,0.08-0.43,0.25-0.6C14.56,4.09,14.76,4,15,4
                            s0.43,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.6V6.9c0,0.23-0.08,0.42-0.25,0.58S15.23,7.71,15,7.71s-0.44-0.08-0.6-0.23
                            S14.14,7.13,14.14,6.9z M19.66,20.08c0-0.23,0.08-0.42,0.23-0.56c0.15-0.16,0.34-0.23,0.56-0.23c0.24,0,0.44,0.08,0.6,0.23
                            l1.46,1.43c0.16,0.17,0.24,0.38,0.24,0.61c0,0.23-0.08,0.43-0.24,0.59c-0.4,0.31-0.8,0.31-1.2,0l-1.42-1.42
                            C19.74,20.55,19.66,20.34,19.66,20.08z M19.66,9.16c0-0.25,0.08-0.45,0.23-0.59l1.42-1.47c0.17-0.16,0.37-0.24,0.59-0.24
                            c0.24,0,0.44,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.6c0,0.25-0.08,0.46-0.24,0.62l-1.46,1.43c-0.18,0.16-0.38,0.24-0.6,0.24
                            c-0.23,0-0.41-0.08-0.56-0.24S19.66,9.4,19.66,9.16z M21.92,14.62c0-0.24,0.08-0.44,0.24-0.62c0.16-0.16,0.35-0.24,0.57-0.24h2.02
                            c0.23,0,0.43,0.09,0.6,0.26c0.17,0.17,0.26,0.37,0.26,0.6s-0.09,0.43-0.26,0.6c-0.17,0.17-0.37,0.25-0.6,0.25h-2.02
                            c-0.23,0-0.43-0.08-0.58-0.25S21.92,14.86,21.92,14.62z">
                            </path>
                        </g>
                    </>
                } 
                {moonrieMove &&
                    <>
                        <circle cx="119" 
                            cy="119" 
                            r="100" 
                            fill="none" 
                            stroke= {colorStroke} 
                            strokeWidth="3" 
                            strokeDasharray={`${progressStroke}, 628`}
                            strokeDashoffset="314" 
                            strokeLinecap="round" 
                            style={{transition: "all 4s ease 1s"}}
                        />
                        <circle 
                            cx="200" 
                            cy="50%" 
                            r="16" 
                            fill="white" 
                            stroke= {colorStroke} 
                            strokeWidth="3" 
                            
                            style={{transformOrigin: "50% 50%", transform: `rotate(${iconRotation}deg) translate(19px)`, transition: "all 4s ease 1s"}}
                        />
                        <g  stroke={colorStroke} fill={colorStroke} x="200" y="50%"
                        style={{transformOrigin: "50% 50%", transform: `rotate(${iconRotation}deg) translate(204px,105px)`, transition: "all 4s ease 1s"}}>
                            <path d="M3.74,14.44c0,2.04,0.5,3.93,1.51,5.65s2.37,3.1,4.1,4.1s3.61,1.51,5.65,1.51s3.92-0.5,5.65-1.51s3.09-2.37,4.09-4.1
                            s1.51-3.61,1.51-5.65s-0.5-3.92-1.51-5.65s-2.37-3.09-4.09-4.09s-3.61-1.51-5.65-1.51S11.08,3.7,9.35,4.7s-3.1,2.37-4.1,4.09
                            S3.74,12.4,3.74,14.44z"></path>
                        </g>
                    </>
                } 
            </svg>
        </div>
    )
}

export default SunMoonRise
